import React, {useState, useEffect} from 'react';
import {Grid, ButtonGroup} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import Form from 'components/Form/FormTwoColumns';
import Table from 'components/Table';
import CitizenIdentityData from './citizenIdentityData';
import BotonPersonalizado from 'components/BotonNormal'
import CustomToolTip from 'components/tooltip/';
import BotonElement from 'components/BotonTable';
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import { showMessagePersonalizedToast, showMessagePersonalizedPosition } from 'services/SweetAlert';
import { Visibility, Done, Search } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import DialogLoadingMessage from 'components/LoadingMessage/index'

const citizenIdentityDataGlobal = [
    { tipo:'Fotografía', foto: ""},
    { tipo:'Firma', foto: ""},
    { tipo:'Huella', foto: ""},
];

const dataCitizenGeneral = {
    fullName: "",
    gender: "",
    dateOfBirth: "",
    birthPlace: "",
    fatherFullName: "",
    motherFullName: "",
    padronData: {
        codStatus: "",
        nombreStatus: "",
    }
}
function Homonimos(props) {
    let history = useHistory();
    const classes = useStyles(),
        [controller] = useState("verificarHomonimos"),
        [loading, setLoading] = useState(false),
        [header, setHeader] = useState([
            { title: 'Código de Referencia', field: 'id', cellStyle: { maxWidth: '80px' } },
            { title: 'Nombre Completo', field: 'nombres', cellStyle: { maxWidth: '100px' } },
            { title: 'Estado Padrón', field: 'datosPadron.estadoPadron.nombreStatus'},
            { title: 'CUI del DPI', field: 'datosPadron.dpi.cui', cellStyle: { maxWidth: '100px' } },
            { title: 'Género', field: 'genero' },
            { title: 'Cédula', field: 'cedula' },
            { title: 'Departamento Cédula', field: 'departamentoCedula.nombre' },
            { title: 'Municipio Cédula', field: 'municipioCedula.name' },
            { title: 'Fecha Nacimiento', field: 'fechaNacimiento', render: (rowData) => functions.splitDate(rowData.fechaNacimiento) },
            { title: 'Departamento Nacimiento', field: 'departamentoNacimiento.nombre' },
            { title: 'Municipio Nacimiento', field: 'municipioNacimiento.name' },
            {
                title: 'Ver imágenes', field: 'showImages',
                render: rowData => <div>
                    {
                        <CustomToolTip title="VER FOTO, FIRMA, HUELLA" handleFunction={() => validarIdentidad(rowData)}><Visibility/></CustomToolTip>
                    }
                </div>
            },
            {
                title: 'Acción', field: 'accion',
                render: rowData => <div>
                    {
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            {/* <BotonElement icon={<Done />} title="Seleccionar ciudadano" /> */}
                            <BotonElement icon={<Done />} title="Seleccionar ciudadano" function={() => seleccionarCiudadano(rowData)} />
                        </ButtonGroup>
                    }
                </div>
            },
        ]),
        [checkAutorization, setCheckAutorization] = useState(false),
        [loadingRequestImages, setLoadingRequestImages] = useState(false),
        [citizenIdentityData, setCitizenIdentityData] = useState([...citizenIdentityDataGlobal]),
        [citizenIdentityDataGeneral, setCitizenIdentityDataGeneral] = useState({...dataCitizenGeneral}),
        [showCitizenIdentityData, setShowCitizenIdentityData] = useState(false),
        [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});
    let filtros = {
        nom1: '', nom2: '', ape1: '', ape2: '',
        cedula: '', genero: '', fechaNacio: '', departamentoNacio: '0', municipioNacio: '0',
    };

    const [elements,setElements] = useState({
        titleHomonimos:{
            idelement: "titleHomonimos",title:'Filtros de Homónimos', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },    
            cui: {
                idelement: "cui",  value:'', label: "CUI del DPI", pattern:"^[0-9]{13}$", 
                validators: ['requireds'], errorMessages:['Ingrese CUI del DPI, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            primerNombre: {
                idelement: "primerNombre",  value:'', label: "Primer nombre", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese primer nombre, sin espacios al inicio y final'], isError:false, elementType:'input',
            },            
            segundoNombre: {
                idelement: "segundoNombre",  value:'', label: "Segundo Nombre", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese segundo nombre, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            primerApellido: {
                idelement: "primerApellido",  value:'', label: "Primer Apellido", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese primer apellido, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            segundoApellido: {
                idelement: "segundoApellido",  value:'', label: "Segundo Apellido", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese segundo apellido, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            ordenCedula: {
                idelement: "ordenCedula",  value:'', label: "Orden de Cédula", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese orden de cédula, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            registroCedula: {
                idelement: "registroCedula",  value:'', label: "Registro de Cédula", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese registro de cédula, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
    });

    const buscarInformacion = async () => {
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){
            if (elements.cui.value || elements.primerNombre.value || elements.segundoNombre.value || elements.primerApellido.value || elements.segundoApellido.value || (elements.ordenCedula.value && elements.registroCedula.value)) {
                setLoadingMessage({loading: true, title: 'Buscando homónimos'})
                setCheckAutorization(false);
                filtros.fechaNacio = ""
                filtros.departamentoNacio = "0"
                filtros.municipioNacio = "0"
                filtros.nom1 =    elements.primerNombre.value ? elements.primerNombre.value : ""
                filtros.nom2 =    elements.segundoNombre.value ? elements.segundoNombre.value : ""
                filtros.ape1 =    elements.primerApellido.value ? elements.primerApellido.value : ""
                filtros.ape2 =    elements.segundoApellido.value ? elements.segundoApellido.value : ""
                filtros.cui = elements.cui.value ? elements.cui.value : ''
                filtros.ordenCedula = elements.ordenCedula.value ? elements.ordenCedula.value:''
                filtros.registroCedula = elements.registroCedula.value ? elements.registroCedula.value:''
    
                try {
                    const hasPermission = await ApiServices.userSecurity.hasPermission('verificarHomonimos','list');    
                    if (hasPermission.error) {
                        setCheckAutorization(false);
                        showMessagePersonalizedToast('error', '¡Oops! ' +hasPermission.error.message)
                        return;
                    }
                   ApiServices[controller].initSearchCriteria.clear();
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("municipioNacio", filtros.municipioNacio);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("departamentoNacio", filtros.departamentoNacio);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("fechaNacio", filtros.fechaNacio);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("nom1", filtros.nom1);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("nom2", filtros.nom2);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("ape1", filtros.ape1);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("ape2", filtros.ape2);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("cui", filtros.cui);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("ordenCedula", filtros.ordenCedula);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("registroCedula", filtros.registroCedula);                   
                   setCheckAutorization(true);
                   setLoadingMessage({loading: false, title: ''})
                } catch (error) {
                    if (error.status === 404) {
                        showMessagePersonalizedToast('error', '¡Oops! ' +'Oops!. Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                    } else {
                        showMessagePersonalizedToast('error', '¡Oops! ' +'Oops!. Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                    }
                }
            } else {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,'Tiene que filtrar como minimo CUI, Primer Nombre, Segundo Nombre, Primer Apellido, Segundo Apellido o Cédula.')
            }
            setLoadingMessage({loading: false, title: ''})
        }
    }

    const next = () => {
        props.MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO({})
        props.MODULO_FALLECIDOS_SET_STEPPER(1)
    }
    
    const seleccionarCiudadano = (data) => {
        props.MODULO_FALLECIDOS_SET_STEPPER(1)
        props.MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO(data)
    }
    const validarIdentidad =async (data)=>{
        setLoadingMessage({loading: true, title: 'Buscando datos de identidad. Espere un momento ...'})
        setCitizenIdentityData([...citizenIdentityDataGlobal]);
        setCitizenIdentityDataGeneral({...dataCitizenGeneral})
        setShowCitizenIdentityData(false)
        const {datosPadron = {}, genero ="", fechaNacimiento= ""} = data;
        const newData = {};
        newData.fullName = `${datosPadron?.primerNombre ? datosPadron?.primerNombre : ""} ${datosPadron?.segundoNombre ? datosPadron?.segundoNombre : ""} , ${datosPadron?.primerApellido ? datosPadron?.primerApellido : ""} ${datosPadron?.segundoApellido ? datosPadron?.segundoApellido : ""} `;
        newData.gender = genero;
        newData.dateOfBirth = fechaNacimiento;
        newData.birthPlace = `${datosPadron.dpi?.municipioNacimientoRenap?.name ? `${datosPadron.dpi?.municipioNacimientoRenap?.name}, ` : ""} ${datosPadron.dpi?.departamentoNacimientoRenap?.name ? datosPadron.dpi?.departamentoNacimientoRenap?.name: ""}`;
        newData.fatherFullName = `${datosPadron?.complemento?.primerNombrePadre ? datosPadron?.complemento?.primerNombrePadre : ""} ${datosPadron?.complemento?.segundoNombrePadre ? datosPadron?.complemento?.segundoNombrePadre : ""} , ${datosPadron?.complemento?.primerApellidoPadre ? datosPadron?.complemento?.primerApellidoPadre : ""} ${datosPadron?.complemento?.segundoApellidoPadre ? datosPadron?.complemento?.segundoApellidoPadre : ""} `;
        newData.motherFullName = `${datosPadron?.complemento?.primerNombreMadre ? datosPadron?.complemento?.primerNombreMadre : ""} ${datosPadron?.complemento?.segundoNombreMadre ? datosPadron?.complemento?.segundoNombreMadre : ""} , ${datosPadron?.complemento?.primerApellidoMadre ? datosPadron?.complemento?.primerApellidoMadre : ""} ${datosPadron?.complemento?.segundoApellidoMadre ? datosPadron?.complemento?.segundoApellidoMadre : ""} `;
        newData.padronData = datosPadron?.estadoPadron ? datosPadron?.estadoPadron : {};

        if(!data.datosPadron?.dpi?.cui) {
            setLoadingMessage({loading: false, title: ''})
            setShowCitizenIdentityData(true)
            setCitizenIdentityDataGeneral(newData);
            return;
        }

        try{
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosPadron?.dpi?.cui);
            if(response.error){
                setShowCitizenIdentityData(true)
                setCitizenIdentityDataGeneral(newData)
            } else {
                const {object} = response.data;

                if(!object) {
                    setShowCitizenIdentityData(true)
                    setCitizenIdentityDataGeneral(newData)
                }
                let newCitizenIdentityData = [];

                newCitizenIdentityData.push({ tipo:'Fotografía', foto: `data:image/jpeg;base64,${object.fotoCiudadano}`});
                newCitizenIdentityData.push({ tipo:'Firma', foto: `data:image/jpeg;base64,${object.firmaCiudadano}`});
                newCitizenIdentityData.push({ tipo:'Huella', foto: `data:image/jpeg;base64,${object.huellaCiudadano}`});
    
                setShowCitizenIdentityData(true)
                setCitizenIdentityData(newCitizenIdentityData)
                setCitizenIdentityDataGeneral(newData)
            } 
        }catch(exception){
            // setOpen(true);
            // (exception.status===404)  ? setMensaje({ tipoError: 'error', tipoMensaje: "Falla del sistema" })
            // : setMensaje({ tipoError: 'error', tipoMensaje: `¡Oops! ${exception.message}`})
        }            
        setLoadingMessage({loading: false, title: ''})
    }    
    const closeShowCitizenIdentityData = () => {
        setShowCitizenIdentityData(false)
    }    

    useEffect(() => {
        if(props.open){
            elements.primerNombre.value = ""
        }
    }, [props.open])
    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <Grid container className={classes.colorComponente}>
                <Grid className={classes.AlignTable} item xs={12}>
                    <Form   elements= {elements}
                    />
                </Grid>
                <Grid item xs={12} className={classes.buttons}>
                    <BotonPersonalizado title={"Buscar"} botonPersonalizado={true} function={buscarInformacion} icon={<Search />} loading={loading} disabled={loading} />
                </Grid>                
                    {
                        (checkAutorization ) ?  (
                            <Grid className={classes.AlignTable} item xs={12}>
                                <Table
                                    service={ApiServices[controller]}
                                    title={"Listado de Homónimos"}
                                    // title={"Listado de Homónimos"}
                                    header={header}
                                    showFilter={false}
                                    showFilterGeneral={false}
                                    selection={true}
                                    onSelectionChange={()=>{}}
                                    pageSize={5}
                                />
                            </Grid>
                        ): 
                        (    
                            <Grid className={classes.AlignAlerta} item xs={12} >
                                <Alert className={classes.AlignAlerta} variant="outlined" severity="warning">Si desea buscar Homónimos, de clic en el botón "BUSCAR"</Alert>
                            </Grid>
                        )
                    }
                <Grid item xs={12} className={classes.buttons}>
                    <BotonPersonalizado title={"Siguiente"} botonSiguiente={true} function={next} />
                    <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={props.handleClose} />
                </Grid>                
                <div className={classes.lineaDegradadaBottom}></div>
            </Grid>
            <CitizenIdentityData citizenIdentityData={citizenIdentityData} showCitizenIdentityData={showCitizenIdentityData} closeShowCitizenIdentityData={ closeShowCitizenIdentityData } citizenIdentityDataGeneral={citizenIdentityDataGeneral}/>          
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(Homonimos);